const authSi = {
    "sign_in": "Prijava",
    "email": "E-poštni naslov",
    "password": "Geslo",
    "sign_in_button": "Prijava",
    "invalid_credentials": "Neveljavne poverilnice",
    "password_min_length": "Geslo mora biti dolgo vsaj 8 znakov",
    "passwords_do_not_match": "Gesli se ne ujemata",
    "invalid_token": "Neveljaven žeton",
    "password_set": "Geslo nastavljeno",
    "confirm_password": "Potrdite geslo",
    "confirm_title": "Potrditev registracije skrbnika Quickpick",
    "confirm_text": "Za nastavitev računa morate le vnesti varno geslo",
    "set_password": "Nastavi geslo",
    "account_activated": "Račun aktiviran",
    "account_activated_text": "Zdaj se lahko prijavite v svoj uporabniški račun z navedenim e-poštnim naslovom in geslom",
    "continue_to_login": "Nadaljuj s prijavo",
    "forgotten_password": "Pozabljeno geslo",
    "unable_to_reset_password": "Notranja napaka, gesla ni mogoče ponastaviti.",
    "reset_password_title": "Ponastavi geslo",
    "reset_password_text": "Vnesite e-poštni naslov, ki ga uporabljate za svoj račun. Na ta e-poštni naslov vam bomo poslali povezavo za ponastavitev gesla.",
    "send_reset_mail": "Pošlji povezavo za ponastavitev gesla",
    "send_reset_mail_success": "Na navedeni naslov je bilo poslano e-poštno sporočilo z nadaljnjimi navodili.",
    "invalid_email": "Neveljaven e-poštni naslov",
    "reset_sent": "E-pošta poslana",
    "change_password_title": "Spremeni geslo",
    "change_password_success": "Geslo je bilo uspešno spremenjeno",
    "roles": {
        "OWNER": "Skrbnik",
        "MENU_EDITOR": "Urejanje menijev",
        "STAFF_MANAGER": "Upravljanje osebja"
    },
    "name": "Ime",
    "permissions": "Dovoljenja",
    "create_user_permissions": "Ustvarjanje uporabniških dovoljenj",
    "add_restaurant": "Dodaj restavracijo",
    "user_saved": "Uporabnik shranjeno",
    "has_admin_permissions": "Skrbniška dovoljenja",
    "login_with_google": "Prijava z Googlom",
    "missing_perrmissions": "Nimate potrebnih dovoljenj za dostop do te strani",
    "qp_signup_title": "Registracija QuickPick",
    "qp_signup_text": "Izpolnite spodnja polja, da ustvarite uporabniški račun!",
    "user_information": "Podatki o uporabniku",
    "restaurant_information": "Informacije o restavraciji",
    "restaurant_shortname": "Identifikator restavracije",
    "restaurant_name": "Ime restavracije",
    "create_profile": "Ustvari",
    "restaurant_name_short": "Ime restavracije mora biti dolgo vsaj 3 znake",
    "identifier_example": "Primer identifikatorja",
    "invalid_shortname": "Identifikator restavracije mora biti dolg vsaj 3 znake",
    "restaurant_shortname_already_in_use": "Identifikator restavracije je že v uporabi",
    "name_missing": "Manjka ime",
    "signup_failed": "Registracija ni uspela. Poskusite znova pozneje.",
    "no_restaurant_title": "Za vaš račun ni izbrana nobena restavracija",
    "no_restaurant_text": "Če ste pravkar ustvarili svoj račun, morate registrirati tudi svojo restavracijo!",
    "no_restaurant_alt": "Če bi morali dobiti dostop do restavracije, se obrnite na skrbnika restavracije.",
    "no_user_created_yet": "Še nimate računa?",
    "signup_success": "Registracija uspešna",
    "grant_admin_title": "Dodeli skrbniška dovoljenja",
    "grant_admin_confirmation": "Uporabnik s skrbniškimi dovoljenji lahko upravlja nastavitve restavracije, dodaja in odstranjuje uporabnike, upravlja naročnine, plačila in račune. Za urejanje menija skrbniška dovoljenja niso potrebna.",
    "selected_user": "Izbrani uporabnik",
    "delete_user_title": "Odstrani uporabnika",
    "delete_user_confirmation": "Izbrani uporabnik bo odstranjen iz restavracije in ne bo imel več dostopa do njenega jedilnika. Tega dejanja ni mogoče razveljaviti.",
    "admin": "Skrbnik",
    "activate_account": "Aktiviraj račun",
    "account_pending_activation": "Vaš uporabniški račun čaka na aktivacijo.",
    "check_your_activate_email": "Prosimo, preverite svoj e-poštni nabiralnik in kliknite aktivacijsko povezavo",
    "refresh_page": "Osveži stran",
    "did_not_receive_activation_email": "Nisem prejel aktivacijskega e-poštnega sporočila",
    "activate_tip": "Če ne najdete aktivacijskega e-poštnega sporočila, preverite tudi mapo z neželeno pošto. Če ga ni tam, kliknite spodnji gumb, da ga ponovno pošljete.",
    "resend_email": "Ponovno pošlji",
    "email_resent": "Aktivacijsko e-poštno sporočilo je bilo uspešno ponovno poslano. Preverite svoj e-poštni nabiralnik.",
    "accept_terms_and_conditions": "Prebral/a sem in sprejemam <a>Pogoje uporabe in Pravilnik o zasebnosti</a>",
    "complete_registration": "Dokončaj registracijo",
    "auth_in_progress": "Poteka preverjanje pristnosti ...",
    "account_successfully_activated": "Vaš račun QuickPick je bil uspešno aktiviran",
    "continue_to_home_page": "Nadaljuj na domačo stran",
    "invalid_activation": "Pri aktivaciji računa je prišlo do napake. Poskusite znova pozneje ali se obrnite na našo podporo strankam.",
    "activation_mail_sent": "Začeli smo ustvarjati vaš račun. Preverite svoj e-poštni nabiralnik in dokončajte registracijo s klikom na povezavo v e-poštnem sporočilu."
};

export default authSi;
